import { APIService } from "../../../../../../network/api/APIService"

export const DashboardLicensesData = ({owner = null, ea = null, globalAppStats=null}) => {
    let endpoint = `/dashboard/licences/`;
    const params = [];

    if (owner !== null) params.push(`owner=${encodeURIComponent(owner)}`);
    if (ea !== null) params.push(`ea=${encodeURIComponent(ea)}`);
    if (globalAppStats !== null) params.push(`global=${encodeURIComponent(globalAppStats)}`);

    if (params.length > 0) {
        endpoint += '?' + params.join('&');
    }

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });
}
